module.exports = __webpack_public_path__ + "static/media/Desert.a863829c.svg";